import { render, staticRenderFns } from "./PageSix.vue?vue&type=template&id=2c04c474&scoped=true&"
import script from "./PageSix.vue?vue&type=script&lang=js&"
export * from "./PageSix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c04c474",
  null
  
)

export default component.exports